import axios from 'axios'
import { setupMobileInterceptors } from './mobileAuthService.js'
import { USE_JWT_COOKIE } from '../../shared/auth/authConfig.js'

/**
 * APIベースURL
 * モバイルトップ画面用のAPIエンドポイント
 */
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/pix/api'

/**
 * モバイルトップ画面用のaxiosインスタンス
 * 共通の設定とインターセプターが適用されたHTTPクライアント
 */
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: USE_JWT_COOKIE,
  headers: {
    'Content-Type': 'application/json',
  },
})

// モバイルトップ画面用のインターセプターを設定
setupMobileInterceptors(apiClient, 'Mobile App Top')

/**
 * モバイルトップ画面サービス
 * イントロ表示、オブジェクト一覧、画像取得などのトップ画面関連機能を提供
 */
export const mobileTopService = {
  /**
   * イントロ表示フラグの取得
   * アプリのイントロ画面表示フラグを取得
   * @returns {Promise<Object>} イントロ表示フラグデータ
   */
  async getIsDisplayIntro() {
    const response = await apiClient.post('/getIsDisplayIntro', {})
    return response.data
  },

  /**
   * イントロ表示フラグの登録
   * アプリのイントロ画面表示フラグを登録
   * @param {number} isDisplayIntro - イントロ表示フラグ（デフォルト: 0）
   * @returns {Promise<Object>} 登録結果
   */
  async registIsDisplayIntro(isDisplayIntro = 0) {
    const response = await apiClient.post('/registIsDisplayIntro', {
      isDisplayIntro: isDisplayIntro
    })
    return response.data
  },

  /**
   * 撮影メモカテゴリーの取得
   * 撮影メモのカテゴリー一覧を取得
   * @returns {Promise<Object>} カテゴリー一覧データ
   */
  async getSatsueiMemoCategory() {
    const response = await apiClient.post('/getSatsueiMemoCategory', {})
    return response.data
  },

  /**
   * オブジェクトリストの取得
   * 条件に基づいてオブジェクト一覧を取得
   * @param {string} satsueiMemoCategoryId - 撮影メモカテゴリーID（デフォルト: ''）
   * @param {number} limit - 取得件数（デフォルト: 60）
   * @param {number} offset - オフセット（デフォルト: 0）
   * @param {number} sort - ソート順（デフォルト: 2 = 更新日時順）
   * @returns {Promise<Object>} オブジェクト一覧データ
   */
  async getObjectList(satsueiMemoCategoryId = '', limit = 60, offset = 0, sort = 2) {
    const response = await apiClient.post('/getObjectList', {
      satsueiMemoCategoryId: satsueiMemoCategoryId,
      limit: limit,
      offset: offset,
      sort: sort // SORT_UPDATE_DATETIME（更新日時順）
    })
    return response.data
  },

  /**
   * 画像URLの取得（サムネイル用）
   * 指定された画像のサムネイル用URLを生成
   * @param {string} objectId - オブジェクトID
   * @param {string} objectImageId - 画像ID
   * @param {string} objectImageEditId - 画像編集ID
   * @param {string} filenameExtension - ファイル拡張子
   * @param {boolean} isUploaded - アップロード済みフラグ
   * @returns {string} 画像URL
   */
  getImageUrl(objectId, objectImageId, objectImageEditId, filenameExtension, isUploaded) {
    return `${API_BASE_URL}/getImage?objectId=${objectId}&objectImageId=${objectImageId}&objectImageEditId=${objectImageEditId}&filenameExtension=${filenameExtension}&isUploaded=${isUploaded}&type=thumb_comp&width=148&height=148`
  }
}